export function Suspense() {
  const emailSupport = "suporte@clinisharp.com";
  return (
    <section className="bg-zinc-50 min-h-screen flex items-center justify-center p-4">
      <div className="bg-white max-w-md w-full rounded-xl shadow-lg overflow-hidden border border-gray-100">
        <div className="bg-red-50 px-6 py-4 border-b border-red-100">
          <div className="flex items-center gap-3">
            <div className="bg-red-100 p-2 rounded-lg">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6 text-red-600"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                />
              </svg>
            </div>
            <h1 className="text-xl font-bold text-gray-800">Conta bloqueada</h1>
          </div>
        </div>

        <div className="px-6 py-5">
          <p className="text-gray-600 mb-4">
            assinatura bloqueada. Em caso de dúvidas ou para mais detalhes,
            entre em contato com nosso time de suporte.
          </p>

          <div className="bg-blue-50 rounded-lg p-4 mb-5">
            <h3 className="font-medium text-blue-800 mb-2 flex items-center gap-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                />
              </svg>
              Contato do suporte
            </h3>
            <ul className="text-sm space-y-1 text-blue-600">
              <li>
                Email: <span className="font-medium">{emailSupport}</span>
              </li>
              <li>
                Telefone: <span className="font-medium">(14) 99193-5325</span>
              </li>
            </ul>
          </div>

          <button
            onClick={() => (window.location.href = `mailto:${emailSupport}`)}
            className="w-full bg-teal-600 hover:bg-teal-700 text-white py-2.5 px-4 rounded-lg font-medium transition-colors flex items-center justify-center gap-2"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
              />
            </svg>
            Enviar e-mail para o suporte
          </button>
        </div>

        <div className="bg-gray-50 px-6 py-3 text-center border-t border-gray-100">
          <p className="text-xs text-gray-500">
            © {new Date().getFullYear()} CliniSharp. Todos os direitos
            reservados.
          </p>
        </div>
      </div>
    </section>
  );
}
